import React from 'react'

const Colli = () => {
  return (
    <div>Colli</div>
  )
}

export default Colli